module.exports = __webpack_public_path__ + "static/media/bg_navigation_screen.4639d9a3.png";